<template>
  <div id="protocol">
    <v-topBar :yellowPageColumn='yellowPageColumn' :productAndSolutionColumn='productAndSolutionColumn' :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl" @selectKeyword = "selectKeyword"> </v-topBar>
    <v-header class="hidden-xs hidden-sm" :navigationColumnInfos='navigationColumnInfos' :webConfigInfo='webConfigInfo'  :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl" @selectKeyword = "selectKeyword"></v-header>
    <div class="protocolCon">
      <v-protocolBanner :bannerInfo='bannerInfo'></v-protocolBanner>
      <div class="searchSupplier">
        <div class="input-group input-group-lg">
          <input type="text" class="form-control"  v-model="selectKeyWord" aria-describedby="sizing-addon1" placeholder="请输入内容" ref="searchKeyword" @keyup.enter="selectKeyword()">
          <span class="input-group-btn">
            <button class="btn btn-default" type="button" @click="selectKeyword()">搜索</button>
          </span>
        </div>
      </div><!-- /.row -->
    </div>
    <div class="protocolTitBox">
      <!--<v-publiceTit :titleObj='titleObj'></v-publiceTit>-->
      <div class="screeningConditions hidden-xs hidden-sm" >
        <div class="conditionsCon">
          <span class="conditionsClass">供应品类：</span>
          <div class="conditionsList">
            <ul class="clearfix">
              <li class="active pull-left" @click="searchProtocol(40,'',$event)">全部</li>
              <li class="pull-left" v-for="(suppliyCatagory,index) in suppliyCatagorys" :key="index" @click="searchProtocol(40,suppliyCatagory,$event)">{{suppliyCatagory}}</li>
            </ul>
          </div>
          <a class="moreProBtn" @click="moreProtocol($event)">展开</a>
        </div>
        <div class="conditionsCon">
          <span class="conditionsClass">品牌名称：</span>
          <div class="conditionsList">
            <ul class="clearfix">
              <li class="active pull-left" @click="searchProtocol(30,'',$event)">全部</li>
              <li class="pull-left"  v-for="(brandName,index) in brandNames" :key="index" @click="searchProtocol(30,brandName,$event)">{{brandName}}</li>
            </ul>
          </div>
          <a class="moreProBtn" @click="moreProtocol($event)">展开</a>
        </div>
      </div>
    </div>
    <div class="protocolTable">
      <div class="tabTitle">
        <div class="mobileNavCon">
        <ul id="protocolTab" class="nav nav-tabs">
          <li class="active">
            <a href="#strategy" data-toggle="tab" @click="selectProtocol(10)">复星战略协议（{{strategicProtocolNumber}}）<div class="tabLine"></div></a>
          </li>
          <li>
            <a href="#appoint" data-toggle="tab" @click="selectProtocol(20)">集团指定协议（{{designatedProtocolNumber}}）<div class="tabLine"></div></a>
          </li>
        </ul>
        </div>
  
        <div class="mobileClass hidden-md hidden-lg">
          <a data-toggle="modal" data-target="#classModal" @click="classShow"><img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/filter_icon.png" alt=""></a>
          <div class="modal fade" id="classModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel">
            <div class="modal-dialog modal-lg" role="document">
              <div class="modal-content">
                <div class="classCon clearfix">
                  <ul id="classTab" class="nav nav-tabs nav-stacked col-xs-3 col-sm-3">
                    <li class="active">
                      <a href="#suppliesClass" data-toggle="tab" @click="selectClass(40)">供应品类</a>
                    </li>
                    <li>
                      <a href="#brandClass" data-toggle="tab" @click="selectClass(30)">品牌名称</a>
                    </li>
                  </ul>
                  <div class="tabCon col-xs-9 col-sm-9">
                    <div id="classTabContent" class="tab-content">
                      <div class="tab-pane fade in active" id="suppliesClass">
                        <a class="allSuppliy allChecked active" @click="allSearch(40,$event)">全部</a>
                        <el-checkbox-group
                          v-model="checkedSuppliy"
                          @change="suppliyChange">
                          <el-checkbox v-for="(suppliyCatagory,index) in suppliyCatagorys" :label="suppliyCatagory" :key="index">{{suppliyCatagory}}</el-checkbox>
                        </el-checkbox-group>
                      </div>
                      <div class="tab-pane fade" id="brandClass">
                        <a class="allBrand allChecked active" @click="allSearch(30,$event)">全部</a>
                        <el-checkbox-group
                          v-model="checkedBrand"
                          @change="brandChange">
                          <el-checkbox v-for="(brandName,index) in brandNames" :label="brandName" :key="index">{{brandName}}</el-checkbox>
                        </el-checkbox-group>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="classBtn clearfix">
                  <el-button class="col-xs-6 col-sm-6" @click="cancelClass(cancelNum)">取消</el-button>
                  <el-button class="col-xs-6 col-sm-6" @click="classHide">确认</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        
      </div>
      <div class="tabCon">
        <div id="protocolTabContent" class="tab-content">
          <div class="clearfix tabConBox tab-pane fade in active" id="strategy">
            <v-protocolTable :protocolList="strategicProtocolList" :viewProtocolDetailUrl="viewProtocolDetailUrl" :tenderLoad="tenderLoad" :keySearch="keySearch" :searchResult="searchResult" :nodata="noData" :currentPageDesignated="currentPageStrategic"></v-protocolTable>
            <v-pagination class="hidden-xs hidden-sm" :total='Number(strategicProtocolNumber)' :display='10' :current-page='currentPageStrategic' @pagechange="pagechange"></v-pagination>
            <div v-show="!searchResult && !noData">
              <a class="listMore hidden-md hidden-lg" v-show="!lineShow&&(strategicProtocolList.length<strategicProtocolNumber)" @click="morePagechange()">MORE</a>
              <p class="lineCon" v-show="lineShow">
                <span class="line"></span>
                <el-button type="text" class="hidden-sm hidden-md hidden-lg" disabled>我也是有底线的</el-button>
                <span class="line"></span>
              </p>
            </div>
          </div>
          <div class="clearfix tabConBox tab-pane fade" id="appoint">
            <v-protocolTable :protocolList="designatedProtocolList" :viewProtocolDetailUrl="viewProtocolDetailUrl" :tenderLoad="tenderLoad" :keySearch="keySearch" :searchResult="searchResult" :nodata="noData" :currentPageDesignated="currentPageDesignated"></v-protocolTable>
            <v-pagination class="hidden-xs hidden-sm" :total='Number(designatedProtocolNumber)' :display='10' :current-page='currentPageDesignated' @pagechange="pagechange"></v-pagination>
            <div v-show="!searchResult && !noData">
              <a class="listMore hidden-md hidden-lg" v-show="!lineShow&&(strategicProtocolList.length<designatedProtocolNumber)" @click="morePagechange()">MORE</a>
              <p class="lineCon" v-show="lineShow">
                <span class="line"></span>
                <el-button type="text" class="hidden-sm hidden-md hidden-lg" disabled>我也是有底线的</el-button>
                <span class="line"></span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-footer :webConfigInfo='webConfigInfo'  :footerColumnInfos='footerColumnInfos' ></v-footer>
    <v-backToTop></v-backToTop>
  </div>
</template>
<script>
  import header from '@/components/v-header/header'
  import protocolBanner from '@/components/protocolBanner'
  import topBar from '@/components/topBar'
  import publiceTit from '@/components/publiceTit'
  import protocolTable from '@/components/protocolTable'
  import footer from '@/components/v-footer'
  import pagination from '@/components/pagination'
  import backToTop from '@/components/backToTop'
  import {customSearchButtonClick} from '@/assets/js/sensors'

  export default {
    data () {
      return {
        checkedSuppliy: [],
        checkedBrand: [],
        hitSearchUrl:'',
        enterpriseResourceBaseUrl:'',
        yellowPageColumn:{},
        productAndSolutionColumn:{},
        strategicAgreementTotal:0,
        designatedTotal:0,
        currentPageStrategic:1,
        currentPageDesignated:1,
        currentPageStrategicMore:2,
        currentPageDesignatedMore:2,
        searchKeyWord:"",
        selectKeyWord:"",
        keySearch:"",
        protocolData: [{
          date: '2018-11-19  12:21',
          title: '广州市番禺区实验中学广州市番禺区实',
          source: '采招系统'
        }, {
          date: '2018-11-20  11:34',
          title: '永康市不动产登记结果自助查询机',
          source: '协同系统'
        }, {
          date: '2018-11-21  12:45',
          title: '笔记本电脑',
          source: '协同系统'
        }, {
          date: '2018-11-22  11:26',
          title: '新川学校周边道路及管线工程施工/标',
          source: '采招系统'
        }, {
          date: '2018-11-19  12:21',
          title: '第四届中国绿化博览会博览园建设项目',
          source: '系统消息'
        }],
        navInfo:{},
        titleObj: {name: '复星集团战略协议名录', eng: 'Strategic agreement'},
        bannerInfo: {},
        webConfigInfo:{},
        footerColumnInfos:[],
        currentPageExt:1,
        currentPageExtMore:2,
        strategicProtocolNumber:0,
        designatedProtocolNumber:0,
        viewProtocolDetailUrl:"",
        strategicProtocolList:[],
        designatedProtocolList:[],
        strategicProtocolExtList:[],
        designatedProtocolExtList:[],
        protocolType:10,
        keyword:"",
        brandNames:[],
        suppliyCatagorys:[],
        selectBrandName:"",
        selectSuppliyCatagory:"",
        navigationColumnInfos:[],
        catagoryList:[],
        brandList:[],
        cancelNum:40,
        suppliyArry:[],
        brandArry:[],
        lineShow:false,
        tenderLoad:true,
        searchResult:false,
        noData:false
      }
    },
    components: {
      'v-header': header,
      'v-protocolBanner': protocolBanner,
      'v-topBar': topBar,
      'v-publiceTit': publiceTit,
      'v-protocolTable': protocolTable,
      'v-footer': footer,
      'v-pagination': pagination,
      'v-backToTop': backToTop

    },
    watch: {
      // 如果 `question` 发生改变，这个函数就会运行
      $route(to,from){
        this.tenderLoad=true;
        this.searchResult = false
        this.noData=false;
        this.keySearch = this.$route.query.searchKeyWord
        if(to.query.searchKeyWord !=''){
         this.searchKeyWord = to.query.searchKeyWord;
          this.selectKeyWord = this.searchKeyWord;
          this.$axios.post('/onelink.mdata.main.api/protocol/selectProtocolInfo', {
            brandName: "",
            effectStatus: "",
            keyword: this.searchKeyWord,
            orderBy: "",
            pageNo: 1,
            pageSize: 10,
            protocolType: "",
            supplyCategory: ""
          }).then((res) => {
            this.data = res.data;
            this.tenderLoad=false;
            this.strategicProtocolList = this.data.strategicProtocolList;
            this.designatedProtocolList = this.data.designatedProtocolList;
            this.strategicProtocolNumber = this.data.strategicProtocolNumber;
            this.strategicProtocolNumber = Number(this.strategicProtocolNumber);
            this.designatedProtocolNumber = Number(this.data.designatedProtocolNumber);
            this.designatedTotal = Number(this.data.designatedProtocolNumber);
            this.viewProtocolDetailUrl = this.data.viewProtocolDetailUrl;
            this.brandNames = this.data.brandNames;
            this.suppliyCatagorys = this.data.suppliyCatagorys;
            this.webConfigInfo = this.data.mainInfo.webConfigInfoDto;
            this.footerColumnInfos = this.data.mainInfo.footerColumnInfos;
            this.navigationColumnInfos = this.data.mainInfo.navigationColumnInfos;
            this.hitSearchUrl = this.data.hitSearchUrl;
            this.yellowPageColumn = this.data.mainInfo.yellowPageColumn;
            this.productAndSolutionColumn = this.data.mainInfo.productAndSolutionColumn;
            this.enterpriseResourceBaseUrl = this.data.enterpriseResourceBaseUrl;
            if(this.protocolType == 10){
              if(this.selectKeyWord){
                this.noData = false;
                if(res.data.strategicProtocolList.length<=0){
                  this.keySearch = this.selectKeyWord;
                  this.searchResult = true
                }else{
                  this.searchResult = false
                }
              }else{
                this.searchResult = false
                if(res.data.strategicProtocolList.length<=0){
                  this.noData = true;
                }else{
                  this.noData = false;
                }
              }
            }
            if(this.protocolType == 20){
              if(this.selectKeyWord){
                this.noData = false;
                if(res.data.designatedProtocolList.length<=0){
                  this.keySearch = this.selectKeyWord;
                  this.searchResult = true
                }else{
                  this.searchResult = false
                }
              }else{
                this.searchResult = false
                if(res.data.designatedProtocolList.length<=0){
                  this.noData = true;
                }else{
                  this.noData = false;
                }
              }
            }
          }).catch((err) => {
            console.log(err)
          })
        }
      }
    },
    created () {
      let query = this.$route.query;
      this.searchKeyWord = query.searchKeyWord;
      this.selectKeyWord = this.searchKeyWord;
      this.$axios.post('/onelink.mdata.main.api/protocol/selectProtocolInfo', {
        brandName: "",
        effectStatus: "",
        keyword: this.searchKeyWord,
        orderBy: "",
        pageNo: 1,
        pageSize: 10,
        protocolType: "",
        supplyCategory: ""
      }).then((res) => {
        this.tenderLoad = false;
        this.data = res.data;
        this.strategicProtocolList = this.data.strategicProtocolList;
        this.designatedProtocolList = this.data.designatedProtocolList;
        this.strategicProtocolNumber = this.data.strategicProtocolNumber;
        this.strategicProtocolNumber = Number(this.strategicProtocolNumber);
        this.designatedProtocolNumber = Number(this.data.designatedProtocolNumber);
        this.designatedTotal = Number(this.data.designatedProtocolNumber);
  
      if(this.selectKeyWord){
        this.noData = false;
        if(res.data.strategicProtocolList.length<=0){
          this.keySearch = this.selectKeyWord;
          this.searchResult = true
        }else{
          this.searchResult = false
        }
      }else{
        this.searchResult = false
        if(res.data.strategicProtocolList.length<=0){
          this.noData = true;
        }else{
          this.noData = false;
        }
      }
      
        this.viewProtocolDetailUrl = this.data.viewProtocolDetailUrl;
        this.brandNames = this.data.brandNames;
        this.suppliyCatagorys = this.data.suppliyCatagorys;
        this.webConfigInfo = this.data.mainInfo.webConfigInfoDto;
        this.footerColumnInfos = this.data.mainInfo.footerColumnInfos;
        this.navigationColumnInfos = this.data.mainInfo.navigationColumnInfos;
        this.hitSearchUrl = this.data.hitSearchUrl;
        this.yellowPageColumn = this.data.mainInfo.yellowPageColumn;
        this.productAndSolutionColumn = this.data.mainInfo.productAndSolutionColumn;
        this.enterpriseResourceBaseUrl = this.data.enterpriseResourceBaseUrl;
      }).catch((err) => {
        console.log(err)
      })
    },
    mounted(){
      this.modalClickFn();
      this.ulWidth();
      this.resizeUlWidth();
    },
    methods:{
      ulWidth () {
        if($('.tabTitle').width() < 750){
          // 动态计算ul的宽度
          let scrollwrap = $('#protocolTab')
          let lis = $('li', scrollwrap)
          let sum = 0
          // 遍历每一个li元素
          lis.each(function (index, el) {
            let _el = $(el)
            // width 宽度 代表的是内容的宽度 innerWidth 代表的是padding + width
            // outerWidth 代表的是border+padding+width
            sum += _el.width()
          })
          // 将累加的值直接复制给ul元素
          scrollwrap.width(sum + 10)
        }
        
      },
      resizeUlWidth(){
        $(window).resize(() => {
          if($('.tabTitle').width() < 750){
            this.ulWidth();
          }else{
            $('#protocolTab').width('auto')
          }
        })
      },
      searchProtocol(selectType,selectKey,$event){
        this.tenderLoad=true;
        this.searchResult = false
        this.noData=false;
        if ($($event.target).hasClass("active")) {
          if ($($event.target).siblings('li').hasClass('active')) {
            $($event.target).removeClass("active");
          } else {
            if ($($event.target).text() != "全部") {
              $($event.target).removeClass("active");
              $($event.target).siblings('li').eq(0).addClass("active");
            }
          }
          //查询协议品类
          if (selectType == 40) {
            for (let i = 0; i < this.catagoryList.length; i++) {
              const element = this.catagoryList[i];
              if (element == selectKey) {
                this.catagoryList.splice(i, 1);
              }
            }
          }
          //查询品牌
          if (selectType == 30) {
            for (let i = 0; i < this.brandList.length; i++) {
              const element = this.brandList[i];
              if (element == selectKey) {
                this.brandList.splice(i, 1);
              }
            }
          }
        } else {
          if ($($event.target).text() != "全部") {
            //查询协议品类
            if (selectType == 40) {
              this.catagoryList.push(selectKey);
            }
            //查询品牌
            if (selectType == 30) {
              this.brandList.push(selectKey);
            }
            $($event.target).addClass("active");
            $($event.target).siblings('li').eq(0).removeClass("active");
          } else {
            //查询协议品类
            if (selectType == 40) {
              this.catagoryList = [];
            }
            //查询品牌
            if (selectType == 30) {
              this.brandList = [];
            }
            $($event.target).addClass("active");
            $($event.target).siblings('li').removeClass("active");
          }
  
  
        }
        
        
        const justPageNo = 0;
        //战略协议
        if(this.protocolType == 10){
          this.justPageNo =  this.currentPageStrategic;
        }

        //指定协议
        if(this.protocolType == 20){
          this.justPageNo =  this.currentPageDesignated;
        }

        //查询品牌
        if(selectType == 30){
          // this.selectBrandName = selectKey;
        }

        //查询协议品类
        if(selectType == 40){
          // this.selectSuppliyCatagory = selectKey;
        }
        this.$axios.post('/onelink.mdata.main.api/protocol/selectProtocolInfo', {
          brandName: this.brandList.join(","),
          supplyCategory: this.catagoryList.join(","),
          status:"40",
          effectStatus: "1",
          keyword: this.selectKeyWord,
          orderBy: "",
          pageNo: this.justPageNo,
          pageSize: 10,
          protocolType: this.protocolType
        }).then((res) => {
          this.tenderLoad = false;
          this.data = res.data;
          //战略协议
          // if(this.protocolType == 10){
          this.strategicProtocolList = this.data.strategicProtocolList;
          this.strategicProtocolNumber = Number(this.data.strategicProtocolNumber);
          // }
  
          //指定协议
          // if(this.protocolType == 20){
          this.designatedProtocolList = this.data.designatedProtocolList;
          this.designatedProtocolNumber = Number(this.data.designatedProtocolNumber);
          // }
          if(this.protocolType == 10){
            if(this.selectKeyWord){
              this.noData = false;
              if(res.data.strategicProtocolList.length<=0){
                this.keySearch = this.selectKeyWord;
                this.searchResult = true
              }else{
                this.searchResult = false
              }
            }else{
              this.searchResult = false
              if(res.data.strategicProtocolList.length<=0){
                this.noData = true;
              }else{
                this.noData = false;
              }
            }
          }
          if(this.protocolType == 20){
            if(this.selectKeyWord){
              this.noData = false;
              if(res.data.designatedProtocolList.length<=0){
                this.keySearch = this.selectKeyWord;
                this.searchResult = true
              }else{
                this.searchResult = false
              }
            }else{
              this.searchResult = false
              if(res.data.designatedProtocolList.length<=0){
                this.noData = true;
              }else{
                this.noData = false;
              }
            }
          }
        }).catch((err) => {
            console.log(err)
        })
        
        
      },
      morePagechange(){
        //战略协议
        if(this.protocolType == 10){
          this.currentPageExtMore = this.currentPageStrategicMore + 1;
        }
        //指定协议
        if(this.protocolType == 20){
          this.currentPageExtMore = this.currentPageDesignatedMore + 1;
        }
        this.$axios.post('/onelink.mdata.main.api/protocol/selectProtocolInfoExt', {
          brandName: this.checkedBrand.join(","),
          supplyCategory: this.checkedSuppliy.join(","),
          keyword: this.selectKeyWord,
          status:"40",
          effectStatus: "1",
          orderBy: "",
          pageNo: this.currentPageExtMore,
          pageSize: 5,
          protocolType: this.protocolType
        }).then((res) => {
          this.data = res.data;
          if(this.data.strategicProtocolList.length<=0){
            this.lineShow=true;
          }
          //战略协议
          if(this.protocolType == 10){
            this.strategicProtocolExtList = this.data.strategicProtocolList;
            this.strategicProtocolExtList.forEach(element =>{
              this.strategicProtocolList.push(element);
            })
            this.strategicProtocolNumber = Number(this.data.strategicProtocolNumber);
            this.currentPageStrategicMore = this.currentPageExtMore;
          }

          //指定协议
          if(this.protocolType == 20){
            this.designatedProtocolExtList = this.data.designatedProtocolList;
            this.designatedProtocolExtList.forEach(element =>{
              this.designatedProtocolList.push(element);
            })
            this.designatedProtocolNumber = Number(this.data.designatedProtocolNumber);
            this.currentPageDesignatedMore = this.currentPageExtMore;
          }
        }).catch((err) => {
          console.log(err)
        })
      },
      pagechange(currentPage){
        //战略协议
        if(this.protocolType == 10){
          this.currentPageStrategic = currentPage;
        }
        //指定协议
        if(this.protocolType == 20){
          this.currentPageDesignated = currentPage;
        }
        this.$axios.post('/onelink.mdata.main.api/protocol/selectProtocolInfoExt', {
          brandName: this.brandList.join(","),
          supplyCategory: this.catagoryList.join(","),
          keyword: this.selectKeyWord,
          status:"40",
          effectStatus: "1",
          orderBy: "",
          pageNo: currentPage,
          pageSize: 10,
          protocolType: this.protocolType
        }).then((res) => {
          this.data = res.data;
          //战略协议
          if(this.protocolType == 10){
            this.strategicProtocolList = this.data.strategicProtocolList;
            this.strategicProtocolNumber = Number(this.data.strategicProtocolNumber);
            this.currentPageStrategic = currentPage;
          }

          //指定协议
          if(this.protocolType == 20){
            this.designatedProtocolList = this.data.designatedProtocolList;
            this.designatedProtocolNumber = Number(this.data.designatedProtocolNumber);
            this.currentPageDesignated = currentPage;
          }
        }).catch((err) => {
          console.log(err)
        })
      },
      selectProtocol(selectProtocolType){
        this.lineShow=false;
        this.tenderLoad=true;
        this.searchResult = false
        this.noData=false;
        //战略协议
        if(this.protocolType == 10){
          this.justPageNo =  this.currentPageStrategic;
          this.currentPageStrategicMore =  2;
        }

        //指定协议
        if(this.protocolType == 20){
          this.justPageNo =  this.currentPageDesignated;
          this.currentPageDesignatedMore =  2;
        }
        this.protocolType = selectProtocolType;
        if(/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)) {
          this.$axios.post('/onelink.mdata.main.api/protocol/selectProtocolInfo', {
            brandName: this.checkedBrand.join(","),
            supplyCategory: this.checkedSuppliy.join(","),
            status:"40",
            effectStatus: "1",
            keyword: this.selectKeyWord,
            orderBy: "",
            pageNo: 1,
            pageSize: 10,
            protocolType: this.protocolType
          }).then((res) => {
            this.tenderLoad = false;
            this.data = res.data;
            //战略协议
            // if(this.protocolType == 10){
            this.strategicProtocolList = this.data.strategicProtocolList;
            this.strategicProtocolNumber = Number(this.data.strategicProtocolNumber);
            // }
    
            //指定协议
            // if(this.protocolType == 20){
            this.designatedProtocolList = this.data.designatedProtocolList;
            this.designatedProtocolNumber = Number(this.data.designatedProtocolNumber);
            // }
            if(this.protocolType == 10){
              if(this.selectKeyWord){
                this.noData = false;
                if(res.data.strategicProtocolList.length<=0){
                  this.keySearch = this.selectKeyWord;
                  this.searchResult = true
                }else{
                  this.searchResult = false
                }
              }else{
                this.searchResult = false
                if(res.data.strategicProtocolList.length<=0){
                  this.noData = true;
                }else{
                  this.noData = false;
                }
              }
            }
            if(this.protocolType == 20){
              if(this.selectKeyWord){
                this.noData = false;
                if(res.data.designatedProtocolList.length<=0){
                  this.keySearch = this.selectKeyWord;
                  this.searchResult = true
                }else{
                  this.searchResult = false
                }
              }else{
                this.searchResult = false
                if(res.data.designatedProtocolList.length<=0){
                  this.noData = true;
                }else{
                  this.noData = false;
                }
              }
            }
          }).catch((err) => {
              console.log(err)
          })
        } else {
          this.$axios.post('/onelink.mdata.main.api/protocol/selectProtocolInfo', {
            brandName: this.brandList.join(","),
            supplyCategory: this.catagoryList.join(","),
            status:"40",
            effectStatus: "1",
            keyword: this.selectKeyWord,
            orderBy: "",
            pageNo: 1,
            pageSize: 10,
            protocolType: this.protocolType
          }).then((res) => {
            this.tenderLoad = false;
            this.data = res.data;
            //战略协议
            // if(selectProtocolType == 10){
            this.strategicProtocolList = this.data.strategicProtocolList;
            this.strategicProtocolNumber = Number(this.data.strategicProtocolNumber);
            // }
    
            //指定协议
            // if(selectProtocolType == 20){
            this.designatedProtocolList = this.data.designatedProtocolList;
            this.designatedProtocolNumber = Number(this.data.designatedProtocolNumber);
            // }
  
            if(this.protocolType == 10){
              if(this.selectKeyWord){
                this.noData = false;
                if(res.data.strategicProtocolList.length<=0){
                  this.keySearch = this.selectKeyWord;
                  this.searchResult = true
                }else{
                  this.searchResult = false
                }
              }else{
                this.searchResult = false
                if(res.data.strategicProtocolList.length<=0){
                  this.noData = true;
                }else{
                  this.noData = false;
                }
              }
            }
            if(this.protocolType == 20){
              if(this.selectKeyWord){
                this.noData = false;
                if(res.data.designatedProtocolList.length<=0){
                  this.keySearch = this.selectKeyWord;
                  this.searchResult = true
                }else{
                  this.searchResult = false
                }
              }else{
                this.searchResult = false
                if(res.data.designatedProtocolList.length<=0){
                  this.noData = true;
                }else{
                  this.noData = false;
                }
              }
            }
          }).catch((err) => {
              console.log(err)
          })
        }
      },
      selectKeyword(val){
        this.lineShow=false;
        this.tenderLoad=true;
        this.searchResult = false
        this.noData=false;
        const justPageNo = 0;
        if(val){
          this.selectKeyWord = val
        }
        //战略协议
        if(this.protocolType == 10){
          this.justPageNo =  this.currentPageStrategic;
        }

        //指定协议
        if(this.protocolType == 20){
          this.justPageNo =  this.currentPageDesignated;
        }
        if(/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)){
          this.$axios.post('/onelink.mdata.main.api/protocol/selectProtocolInfo', {
            brandName: this.checkedBrand.join(","),
            supplyCategory: this.checkedSuppliy.join(","),
            status:"40",
            effectStatus: "1",
            keyword: this.selectKeyWord?this.selectKeyWord.trim():this.selectKeyWord,
            orderBy: "",
            pageNo: 1,
            pageSize: 10,
            protocolType: this.protocolType
          }).then((res) => {
            this.tenderLoad = false;
            this.data = res.data;
            //战略协议
            // if(this.protocolType == 10){
            this.strategicProtocolList = this.data.strategicProtocolList;
            this.strategicProtocolNumber = Number(this.data.strategicProtocolNumber);
            // }
    
            //指定协议
            // if(this.protocolType == 20){
            this.designatedProtocolList = this.data.designatedProtocolList;
            this.designatedProtocolNumber = Number(this.data.designatedProtocolNumber);
            // }
          if(this.protocolType == 10){
            if(this.selectKeyWord){
              this.noData = false;
              if(res.data.strategicProtocolList.length<=0){
                this.keySearch = this.selectKeyWord;
                this.searchResult = true
              }else{
                this.searchResult = false
              }
            }else{
              this.searchResult = false
              if(res.data.strategicProtocolList.length<=0){
                this.noData = true;
              }else{
                this.noData = false;
              }
            }
          }
          if(this.protocolType == 20){
            if(this.selectKeyWord){
              this.noData = false;
              if(res.data.designatedProtocolList.length<=0){
                this.keySearch = this.selectKeyWord;
                this.searchResult = true
              }else{
                this.searchResult = false
              }
            }else{
              this.searchResult = false
              if(res.data.designatedProtocolList.length<=0){
                this.noData = true;
              }else{
                this.noData = false;
              }
            }
          }
          
          }).catch((err) => {
              console.log(err)
          })
        }else {
          this.$axios.post('/onelink.mdata.main.api/protocol/selectProtocolInfo', {
            brandName: this.brandList.join(","),
            supplyCategory: this.catagoryList.join(","),
            status:"40",
            effectStatus: "1",
            keyword: this.selectKeyWord,
            orderBy: "",
            pageNo: this.justPageNo,
            pageSize: 10,
            protocolType: this.protocolType
          }).then((res) => {
            this.tenderLoad = false;
            this.data = res.data;
            //战略协议
            // if(this.protocolType == 10){
            this.strategicProtocolList = this.data.strategicProtocolList;
            this.strategicProtocolNumber = Number(this.data.strategicProtocolNumber);
            // }
    
            //指定协议
            // if(this.protocolType == 20){
            this.designatedProtocolList = this.data.designatedProtocolList;
            this.designatedProtocolNumber = Number(this.data.designatedProtocolNumber);
            // }
            if(this.protocolType == 10){
              if(this.selectKeyWord){
                this.noData = false;
                if(res.data.strategicProtocolList.length<=0){
                  this.keySearch = this.selectKeyWord;
                  this.searchResult = true
                }else{
                  this.searchResult = false
                }
              }else{
                this.searchResult = false
                if(res.data.strategicProtocolList.length<=0){
                  this.noData = true;
                }else{
                  this.noData = false;
                }
              }
            }
            if(this.protocolType == 20){
              if(this.selectKeyWord){
                this.noData = false;
                if(res.data.designatedProtocolList.length<=0){
                  this.keySearch = this.selectKeyWord;
                  this.searchResult = true
                }else{
                  this.searchResult = false
                }
              }else{
                this.searchResult = false
                if(res.data.designatedProtocolList.length<=0){
                  this.noData = true;
                }else{
                  this.noData = false;
                }
              }
            }
          }).catch((err) => {
              console.log(err)
          })
        }

        // 埋点
        try {
          customSearchButtonClick({position: "复星战略协议搜索"})
        } catch (e) {
          console.log(e)
        }

      },
      moreProtocol(e){
//        console.log($(e.target).siblings('.conditionsList').height())
        let sibHeight = $(e.target).siblings('.conditionsList').height()
        if(sibHeight>27){
          $(e.target).siblings('.conditionsList').height('24px');
          $(e.target).parent('.conditionsCon').height('24px');
          $(e.target).siblings('.conditionsList').css('overflow-y','hidden');
          $(e.target).text('展开')
        }else{
//          $(e.target).siblings('.conditionsList').height('60px');
          $(e.target).siblings('.conditionsList').height('auto');
          $(e.target).parent('.conditionsCon').height('auto');
          $(e.target).siblings('.conditionsList').css('overflow-y','auto');
          $(e.target).text('收起')
        }
      },
//      分类弹窗
      selectClass(val){
        this.cancelNum=val
      },
//      筛选图标按钮
      classShow(){
        this.suppliyArry=this.checkedSuppliy;
        this.brandArry=this.checkedBrand;
      },
//      确定按钮
      classHide(){
        this.lineShow=false;
        this.tenderLoad=true;
        this.searchResult = false
        this.noData=false;
        const justPageNo = 0;
        //战略协议
        if(this.protocolType == 10){
          this.justPageNo =  this.currentPageStrategic;
        }
  
        //指定协议
        if(this.protocolType == 20){
          this.justPageNo =  this.currentPageDesignated;
        }
        this.$axios.post('/onelink.mdata.main.api/protocol/selectProtocolInfo', {
          brandName: this.checkedBrand.join(","),
          supplyCategory: this.checkedSuppliy.join(","),
          status:"40",
          effectStatus: "1",
          keyword: this.selectKeyWord,
          orderBy: "",
          pageNo: this.justPageNo,
          pageSize: 10,
          protocolType: this.protocolType
        }).then((res) => {
          this.tenderLoad=false;
          this.data = res.data;
        //战略协议
        // if(this.protocolType == 10){
          this.strategicProtocolList = this.data.strategicProtocolList;
          this.strategicProtocolNumber = Number(this.data.strategicProtocolNumber);
          // }
    
          //指定协议
          // if(this.protocolType == 20){
          this.designatedProtocolList = this.data.designatedProtocolList;
          this.designatedProtocolNumber = Number(this.data.designatedProtocolNumber);
          // }
  
          if(this.protocolType == 10){
            if(this.selectKeyWord){
              this.noData = false;
              if(res.data.strategicProtocolList.length<=0){
                this.keySearch = this.selectKeyWord;
                this.searchResult = true
              }else{
                this.searchResult = false
              }
            }else{
              this.searchResult = false
              if(res.data.strategicProtocolList.length<=0){
                this.noData = true;
              }else{
                this.noData = false;
              }
            }
          }
          if(this.protocolType == 20){
            if(this.selectKeyWord){
              this.noData = false;
              if(res.data.designatedProtocolList.length<=0){
                this.keySearch = this.selectKeyWord;
                this.searchResult = true
              }else{
                this.searchResult = false
              }
            }else{
              this.searchResult = false
              if(res.data.designatedProtocolList.length<=0){
                this.noData = true;
              }else{
                this.noData = false;
              }
            }
          }
        
        }).catch((err) => {
            console.log(err)
        })
        $('#classModal').modal('hide')
      },
//      取消按钮
      cancelClass(val){
        $('#classModal').modal('hide');
        this.checkedSuppliy=this.suppliyArry;
        this.checkedBrand=this.brandArry
      },
//      供应品类数据操作
      suppliyChange(val){
        if(val.length<=0){
          $('.allSuppliy').eq(0).addClass('active');
        }else{
          $('.allSuppliy').eq(0).removeClass('active');
        }
      },
//      品牌名称数据操作
      brandChange(val){
        if(val.length<=0){
          $('.allBrand').eq(0).addClass('active');
        }else{
          $('.allBrand').eq(0).removeClass('active');
        }
      },
//      模态框关闭事件
      modalClickFn(){
        $('#classModal').on('click', (e) => {
          if(e.target.id=='classModal'){
            this.cancelClass();
          }
        })
      },
//      条件全部点击
      allSearch(val,e){
        if(val==40){
          this.checkedSuppliy=[];
        };
        if(val==30){
          this.checkedBrand=[];
        };
        $(e.target).addClass('active');
      }
      
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/protocol/index.vue